// KU - return an instance of `URL`, which unlike `Location`, is an api
// available in both node and the browser
export const getCurrentURL = () => new URL(window.location.toString(), window.origin);
export { generatePath, matchPath } from 'react-router-dom';
